//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "popUp",

  props: {
    showFlag: {
      type: Boolean
    },
    height: {
      type: Number,
    },

    // open: { //打开弹窗回调
    //   type: Function,
    // },
    // close: { //关闭弹窗回调
    //   type: Function,
    // }
  },
  watch: {
    showFlag: {
      handler(newData, ordData) {
        if (newData === true) {
          this.$emit("open"); //打开弹窗回调
        } else {
          this.$emit("close"); //关闭弹窗回调
        }
      }
    }
  },
  data() {
    return {
      closeBtn: require("../../assets/image/icon/close_btn.png"),
      classname:"",
    };
  },
  methods: {
    close() {
      this.$emit("close");
    }
  },
  mounted() {
    // let system = JSON.parse(native.getDeviceInfo()).system;
    // if (system != "iOS") {
    //   this.classname="padding_botton"
    // }
  }
};



// WEBPACK FOOTER //
// ./src/components/popup/popup.vue